import { useEffect, useRef } from 'react';
import { noop } from 'lodash';

export const useDisableSelection = () => {
  const targetRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = targetRef.current;
    if (!element) return noop;

    const originalUserSelect = element.style.userSelect;

    const preventSelection = (e: Event) => {
      e.preventDefault();
      return false;
    };

    const preventCopy = (e: ClipboardEvent) => {
      e.preventDefault();
      return false;
    };

    const clearSelection = () => {
      if (window.getSelection) {
        const selection = window.getSelection();
        if (selection) selection.removeAllRanges();
      }
    };

    const preventContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    const handleSelectionChange = () => {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      if (!range) return;

      if (element.contains(range.commonAncestorContainer)) {
        clearSelection();
      }
    };

    element.addEventListener('selectstart', preventSelection);
    element.addEventListener('copy', preventCopy);
    element.addEventListener('contextmenu', preventContextMenu);
    document.addEventListener('selectionchange', handleSelectionChange);

    element.style.userSelect = 'none';

    const style = document.createElement('style');
    style.innerHTML = `
      .disable-selection {
        user-select: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
      }
    `;
    document.body.appendChild(style);
    element.classList.add('disable-selection');

    return () => {
      element.removeEventListener('selectstart', preventSelection);
      element.removeEventListener('copy', preventCopy);
      element.removeEventListener('contextmenu', preventContextMenu);
      document.removeEventListener('selectionchange', handleSelectionChange);

      element.style.userSelect = originalUserSelect;

      element.classList.remove('disable-selection');
      document.body.removeChild(style);
    };
  }, []);

  return targetRef;
};
